export default "__VITE_ASSET__BfXxAuXK__"